var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E84142"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.921 14.3397C18.3061 13.7046 18.9275 13.7046 19.3126 14.3397L21.7106 18.3593C22.0957 18.9944 21.7807 19.5125 21.0105 19.5125H16.1793C15.4178 19.5125 15.1028 18.9944 15.4791 18.3593L17.921 14.3397ZM13.2823 6.60133C13.6674 5.96622 14.2801 5.96622 14.6652 6.60133L15.199 7.52058L16.4594 9.63483C16.7657 10.2365 16.7657 10.9468 16.4594 11.5485L12.2321 18.5431C11.847 19.1114 11.2081 19.4707 10.4991 19.5125H6.98953C6.21934 19.5125 5.90426 19.0027 6.28936 18.3593L13.2823 6.60133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 15.75,
    fill: "white",
    transform: "translate(6.125 6.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/Avalanche.e093011d8cd129e25a05a5268220cfb7.svg";
export { ForwardRef as ReactComponent };